import { render, staticRenderFns } from "./IconCodeSnippetVue.vue?vue&type=template&id=12c33f57"
import script from "./IconCodeSnippetVue.vue?vue&type=script&lang=js"
export * from "./IconCodeSnippetVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports